import { Box, styled, Typography } from '@mui/material';

import BaseButton from '../../../../../../../core/presentation/components/base-button/base-button';

export const ValidadeCodeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '500px',
  gap: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    minWidth: theme.spacing(60)
  },
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
    width: '100%'
  },
  '@media (max-height: 700px)': {
    gap: theme.spacing(2)
  }
}));

export const AlertBox = styled(Box)(({ theme }) => ({
  width: '100%',
  fontSize: theme.typography.pxToRem(14)
}));

export const VerificationBox = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center'
}));

export const ResendCodeButton = styled(BaseButton)(() => ({
  textDecoration: 'underline'
}));

export const ResendText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
  fontSize: theme.typography.pxToRem(14)
}));
